import React from "react";
import Icon from "../../../../../../shared-components/css-modules/toyota/atoms/Icon";
import Button from "../../../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "./CalculatorError.module.scss";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import { CarConfigLabel } from "../../../../../utils/labelUtils";

type Props = {
    containerId?: string;
};

const CalculatorError = ({ containerId }: Props): JSX.Element => {
    return (
        <div id={containerId} className={styles["calculator-error-wrapper"]}>
            <Icon variant="error" sizing="xl" aria-hidden="true" />
            <Text variant="apheleia-h3">
                <strong>
                    <CarConfigLabel label="carConfigCalculatorErrorTitle" />
                </strong>
            </Text>
            <Text variant="body-book" color="grey-7">
                <CarConfigLabel label="carConfigCalculatorErrorDescription" />
            </Text>
            <Button onClick={() => window.location.reload()} variant="btn-secondary">
                <CarConfigLabel label="carConfigCalculatorErrorButton" />
            </Button>
        </div>
    );
};

export default CalculatorError;
